"use strict";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import {
  ChartDataset,
  ChartType,
  LegendItem } from "chart.js";
import { Subscription } from "rxjs";
import { CapitalAllowanceChartService } from "../../../../../../../swaggerServices/api/CapitalAllowanceChartService";

declare var require: any;

import { BaseChartDirective } from "ng2-charts";
import { ChartTypeService } from "../../../../../../../swaggerServices";

@Component({
    selector: "app-chart",
    templateUrl: "./chart.component.html",
    styleUrls: ["./chart.component.scss"],
    standalone: false
})
export class ChartComponent implements OnInit {
  
  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;

  @Input() chartData;
  @Input() chartTypeName: string;

  configuration: any;
  
  loaded = false;
  chartLabels: string[];
  chartType: ChartType;
  dataset: ChartDataset[];
  requirementsMet: boolean;
  errorMessage: string;
  data;

  checkValue;
  chartTitle;
  legendItem: LegendItem[];
  subscriptions: Subscription[] = [];

  constructor(public chartTypeService: ChartTypeService) {}

  ngOnInit() {
    this.getChartConfig();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  populateChartConfig() {
    this.chartTitle = CapitalAllowanceChartService.getTitle(this.chartTypeName);
    this.chartLabels = this.chartData 
      ? this.chartData[0].answers.map((a: { answer: string }) => a.answer)
      : [];
    this.errorMessage = CapitalAllowanceChartService.checkLabels(this.chartLabels);
    this.requirementsMet = this.errorMessage ? false : true;
    this.loaded = !this.requirementsMet;

    if (this.requirementsMet) {
      const data = this.chartData.filter((c, idx) => idx !== 0 && !c.isRowId);
      const colHeader = data.map(a => a.question);
      const columnData = data.map(a => a.answers.map((a) => a.answer));

      this.dataset = CapitalAllowanceChartService.getData(colHeader, columnData);
      this.errorMessage = CapitalAllowanceChartService.checkValue(columnData);
      this.requirementsMet = this.errorMessage ? false : true;
      this.loaded = !this.requirementsMet;

      this.configuration = {
        ...CapitalAllowanceChartService.getDefaultChartConfig(),
        data: {
          labels: this.chartLabels,
          datasets: this.dataset,
        },
        invalid: this.errorMessage,
      };
    }
  }

  getChartConfig() {
    this.subscriptions.push(
      this.chartTypeService.chartTypeConfigBuilder(this.chartTypeName)
        .subscribe(result => this.getChartStructure(result)
      ));
  }

  getChartStructure(data: object) {
    const config = Object.entries(data).map(x => x[1]);
    this.configuration = config[0];
    this.chartType = this.configuration.type;
    this.errorMessage = CapitalAllowanceChartService.checkChartRequirements(
      this.chartData,
      this.configuration.minColumnsRequired
    );

    this.requirementsMet = this.errorMessage ? false : true;
    this.loaded = !this.requirementsMet;

    if (this.requirementsMet) {
      this.populateChartConfig();
    }
  }
}
